import React, { useEffect, useState } from 'react';
import Card from '../../ui/Card';
import ChartAnnotation from '../../ui/ChartAnnotation';
import LoadingChart from '../../ui/LoadingChart';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const RevenueLineChart: React.FC = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);
  const data = [{
    month: 'Jan',
    Lighting: 180,
    Polymer: 145,
    Electrical: 220,
    Safety: 95
  }, {
    month: 'Feb',
    Lighting: 195,
    Polymer: 152,
    Electrical: 235,
    Safety: 102
  }, {
    month: 'Mar',
    Lighting: 210,
    Polymer: 168,
    Electrical: 248,
    Safety: 108
  }, {
    month: 'Apr',
    Lighting: 198,
    Polymer: 160,
    Electrical: 242,
    Safety: 105
  }, {
    month: 'May',
    Lighting: 215,
    Polymer: 175,
    Electrical: 258,
    Safety: 112
  }, {
    month: 'Jun',
    Lighting: 228,
    Polymer: 182,
    Electrical: 268,
    Safety: 118
  }, {
    month: 'Jul',
    Lighting: 235,
    Polymer: 188,
    Electrical: 275,
    Safety: 122
  }, {
    month: 'Aug',
    Lighting: 242,
    Polymer: 195,
    Electrical: 285,
    Safety: 128
  }, {
    month: 'Sep',
    Lighting: 238,
    Polymer: 192,
    Electrical: 280,
    Safety: 125
  }, {
    month: 'Oct',
    Lighting: 248,
    Polymer: 198,
    Electrical: 292,
    Safety: 132
  }, {
    month: 'Nov',
    Lighting: 255,
    Polymer: 205,
    Electrical: 298,
    Safety: 138
  }, {
    month: 'Dec',
    Lighting: 262,
    Polymer: 212,
    Electrical: 305,
    Safety: 142
  }];
  return <Card className="p-6 relative" data-id="element-9048">
      <ChartAnnotation type="trend-up" text="Strong Q4 Growth" data-id="element-9049" />
      <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-9050">
        Revenue by Product Line
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-9051">Monthly revenue trend (₹ Cr)</p>
      {loading ? <div className="h-[300px]" data-id="element-9052">
          <LoadingChart data-id="element-9053" />
        </div> : <ResponsiveContainer width="100%" height={300} data-id="element-9054">
          <LineChart data={data} data-id="element-9055">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-9056" />
            <XAxis dataKey="month" tick={{
          fontSize: 12,
          fill: '#6b7280'
        }} data-id="element-9057" />
            <YAxis tick={{
          fontSize: 12,
          fill: '#6b7280'
        }} data-id="element-9058" />
            <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '12px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }} data-id="element-9059" />
            <Legend wrapperStyle={{
          paddingTop: '20px'
        }} data-id="element-9060" />
            <Line type="monotone" dataKey="Lighting" stroke="#3b82f6" strokeWidth={2.5} dot={{
          r: 4,
          strokeWidth: 2
        }} data-id="element-9061" />
            <Line type="monotone" dataKey="Polymer" stroke="#10b981" strokeWidth={2.5} dot={{
          r: 4,
          strokeWidth: 2
        }} data-id="element-9062" />
            <Line type="monotone" dataKey="Electrical" stroke="#f59e0b" strokeWidth={2.5} dot={{
          r: 4,
          strokeWidth: 2
        }} data-id="element-9063" />
            <Line type="monotone" dataKey="Safety" stroke="#ef4444" strokeWidth={2.5} dot={{
          r: 4,
          strokeWidth: 2
        }} data-id="element-9064" />
          </LineChart>
        </ResponsiveContainer>}
    </Card>;
};
export default RevenueLineChart;